var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pwa-payments-header mb-4" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "payments-card" }, [
      _c(
        "div",
        { staticClass: "country-tabs" },
        _vm._l(_vm.usedCountries, function (country) {
          return _c(
            "button",
            {
              key: country.code,
              staticClass: "country-tab",
              class: { active: _vm.selectedCountry === country.code },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.selectCountry(country.code)
                },
              },
            },
            [
              country.flag
                ? _c("span", { staticClass: "mr-2" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(country.flag) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(
                "\n                " + _vm._s(country.name) + "\n            "
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gateway-tabs" },
        _vm._l(_vm.filteredGates, function (gate) {
          return _c(
            "button",
            {
              key: gate.id,
              staticClass: "gateway-card",
              class: { active: _vm.selectedGateId === gate.id },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.selectGate(gate)
                },
              },
            },
            [
              _c(
                "span",
                { staticClass: "gateway-logo", class: gate.view_class },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.gateShortName(gate)) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "gateway-title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(gate.name) +
                    "\n                "
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.selectedGateId > 0
        ? _c(
            "div",
            { staticClass: "header-actions mt-3" },
            [
              _c("div", { staticClass: "selected-gate-info" }, [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.__t("SELECTED_GATE")) +
                      ":\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("strong", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.selectedGate ? _vm.selectedGate.name : "") +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "ml-auto",
                  attrs: { variant: "primary" },
                  on: { click: _vm.createPayment },
                },
                [
                  _c("i", { staticClass: "fal fa-plus mr-1" }),
                  _vm._v("\n                Налаштувати шлюз\n            "),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payments-title mb-3" }, [
      _c("h2", { staticClass: "mb-1" }, [
        _vm._v("\n            PWA Payments\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted" }, [
        _vm._v(
          "\n            Централізоване управління способами оплати для PWA-додатків.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }